import { render, staticRenderFns } from "./LearningRequestCreateV2.vue?vue&type=template&id=351fdc2f&"
import script from "./LearningRequestCreateV2.vue?vue&type=script&lang=ts&"
export * from "./LearningRequestCreateV2.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports